import { createApp } from "vue";

import MessageToSentry from "@component_path/lib/messageToSentry";
import AgentSelectionForm from "@component_path/pages/pc/agent_selection/secret";
import store from "@component_path/agent_selection_wish_module/store";

document.addEventListener("DOMContentLoaded", () => {
  const node = document.getElementById("agent-selection-form-data");
  const props = JSON.parse(node.getAttribute("data"));

  const app = createApp(AgentSelectionForm, props);
  app.config.errorHandler = MessageToSentry.fromVueInstance;
  app.use(store).mount("#agent-selection-form");
});
